import { domainThemes } from "../helpers/page-constants";

export const getDomainTheme = (product) => {
  const defaultTheme = {
    logo: "/images/header/logo.svg",
  };
  const theme = domainThemes[product] ? domainThemes[product] : defaultTheme;
  return theme;
};
